import { Link } from "react-router-dom";

function HomeAdmin({ allowedPages,fullName }) {
  const links = new Set();

  allowedPages.forEach((e) => {
    if (e === "all") {
      links.add({ path: "/masterCourse", label: "MASTER COURSES" });
      links.add({ path: "/marksEntryCourses", label: "MARKS ENTRY" });
      links.add({ path: "/gradeEntryCourses", label: "GRADE COMPUTATION" });
      links.add({ path: "/submittedGrades", label: "SUBMITTED GRADES" });
      links.add({ path: "/editresult", label: "EDIT RESULT OF A STUDENT" });
      links.add({ path: "/resultdeclarationbatches", label: "RESULT BATCHES" });
       links.add({ path: "/formfillupbatchswitches", label: "FORM FILLUP BATCH SWITCHES" });
       links.add({ path: "/convoswitches", label: "CONVOCATION SWITCHES" });
      links.add({ path: "/editcertificates", label: "EDIT CONVO CERTIFICATE DETAILS" });
      links.add({ path: "/generatecertificates", label: "CONVO CERTIFICATES" });

      links.add({ path: "/formfillupDetails", label: "FORM FILLUP REPORT" });
      links.add({ path: "/studenttranscript", label: "STUDENT TRANSCRIPT" });
      
    } else if (e === "mastercourse") {
      links.add({ path: "/masterCourse", label: "MASTER COURSES" });
    } else if (e === "marksentry") {
      links.add({ path: "/marksEntryCourses", label: "MARKS ENTRY" });
    } else if (e === "gradeentry") {
      links.add({ path: "/gradeEntryCourses", label: "GRADE COMPUTATION" }); 
    } else if (e === "submittedgrades") {
      links.add({ path: "/submittedGrades", label: "SUBMITTED GRADES" });
    }
  });

  return (
    <main className="flex flex-col items-center p-4">
      <div className="w-full border-b border-gray-200 flex flex-col text-center">
        <p className="text-xs sm:text-sm text-gray-400">Welcome</p>
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-400 mb-2">
          {fullName}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {[...links].map((link, index) => (
          <Link key={index} to={link.path}>
            <div className="w-[150px] h-[150px] bg-gradient-to-r from-blue-400 to-blue-200 text-gray-800 p-2 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-400 hover:text-white transition-all cursor-pointer flex items-center justify-center text-center text-xs">
              {link.label}
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default HomeAdmin;
